module.exports = __webpack_public_path__ + "static/media/fist.ce6b5810.svg";